import {useRef} from 'react';

import {SimpleGrid} from '@mantine/core';
import {useNavigate} from 'react-router-dom';

import {useMeteringRecords} from '../hooks/useMeteringRecords.ts';
import {useTableColumns} from '../hooks/useTableColumns.tsx';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import {DataTableTokenPagination} from "../../../components/DataTableTokenPagination.tsx";

export const RecordsTable = () => {
    const {columns} = useTableColumns();
    const navigate = useNavigate();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useMeteringRecords();

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    // Read-only (FNP-534): no selection / no edit drawer. Row click opens the
    // detail view. MeteringRecord has a TWO-PART key: customerId (PK) + sortKey
    // (SK = `meterId#periodStart#dimensionsHash`). The route is two segments
    // (`:customerId/:sortKey`) mapping 1:1 to getMeteringRecord(customerId, sortKey).
    // BOTH segments MUST be encodeURIComponent'd: sortKey contains `#` (a URL
    // fragment delimiter) so an unencoded value would truncate the path, useParams
    // would return a partial key, and getMeteringRecord(<partial>) returns nothing
    // → the detail page hangs on its loader forever. react-router v6 useParams()
    // auto-decodes each segment, so the detail page receives the original values.
    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword}/>

            <MantineDataTable
                columns={columns}
                records={items}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
                onRowClick={({record}) => navigate(`/metering-records/${encodeURIComponent(record.customerId)}/${encodeURIComponent(record.sortKey)}`)}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken}
                                      handleLoadMore={fetchRecords}/>
        </SimpleGrid>
    );
};
